import React, { Component } from 'react';
import UrlConstants from '../../constants/UrlConstants';
import { Dispatch } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from '@mui/material';
import { List as ImmutableList } from 'immutable';
import { RootState } from '../../setup';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@mui/styles';
import IMenuItem from '../../interfaces/common/menuItem';
import MainLayout from '../common/widgets/mainLayout';
import PageUtils from '../../utils/pageUtils';
import { Theme } from '@mui/material';
import { ObjectType } from '../../constants/constants';
import Paging from '../../interfaces/common/paging';
import LanguageUtils from '../../utils/LanguageUtils';
import { GridSortModel, GridSortDirection, GridSortItem, GridColumnVisibilityModel } from '@mui/x-data-grid';
import SurchargeRate from '../../interfaces/output/surchargeRate';
import { fetchSurchargeRateById, getSurchargeRate, isLoadingSurchargeRate, resetSurchargeRate } from '../../reducers/surchargeRateReducer';
import ViewSurchargeRate from './viewSurchargeRate';

interface ISurchargeRateDetailsProps {
    classes: any;
    theme: Theme;
    fetchSurchargeRateById: any;
    surchargeRate: SurchargeRate;
    match: any;
    history: any;
    location: any;
    isLoadingSurchargeRate: boolean;
    resetSurchargeRate: () => void;
}

interface ISurchargeRateDetailsState {
    surchargeRate: SurchargeRate;
    menuItems: ImmutableList<IMenuItem>;
    selectedRow?: number;
    serverProductPagination: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchSurchargeRateById: (surchargeRateId: any) => dispatch(fetchSurchargeRateById(surchargeRateId)),
    resetSurchargeRate: () => dispatch(resetSurchargeRate())
});

const messages = {
    edit: LanguageUtils.createMessage('Edit'),
    properties: LanguageUtils.createMessage('Properties'),
    subname: LanguageUtils.createMessage('Surcharge Rates')
};

const mapStoreToProps = (store: RootState) => {
    return {
        surchargeRate: getSurchargeRate(store),
        isLoadingSurchargeRate: isLoadingSurchargeRate(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        padding: theme.spacing(4)
    },
    link: {
        textDecoration: 'none',
        color: `${theme.palette.info.main}!important`,
        fontSize: '12px!important'
    }
});

class SurchargeRateDetails extends Component<ISurchargeRateDetailsProps, ISurchargeRateDetailsState> {
    constructor(props: ISurchargeRateDetailsProps) {
        super(props);

        this.state = {
            surchargeRate: {} as SurchargeRate,
            menuItems: ImmutableList([{
                id: 1,
                name: messages.properties,
                icon: <FontAwesomeIcon icon="info-circle" size="1x" transform="grow-4" />,
                additionalMargin: true,
                url: `/${UrlConstants.SURCHARGE_RATES}/${props.match.params.surchargeRateId}/properties`,
                isSelected: PageUtils.isPageSelected(`/${UrlConstants.SURCHARGE_RATES}/${props.match.params.surchargeRateId}/properties`, props.location.pathname)
            }
            ]),
            serverProductPagination: PageUtils.getDefaultPaging(),
            selectedRow: undefined,
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {

            }
        };
    }

    componentDidMount() {
        const { fetchSurchargeRateById } = this.props;
        const { surchargeRateId } = this.props.match.params;

        fetchSurchargeRateById(surchargeRateId);
    }

    componentDidUpdate(prevProps: ISurchargeRateDetailsProps) {
        const { surchargeRate } = this.props;

        if(surchargeRate !== prevProps.surchargeRate) {
            this.setState({ surchargeRate });
        }

        if(prevProps.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
            const menuItems = this.state.menuItems.map((menuItem: IMenuItem) => {
                menuItem.isSelected = PageUtils.isPageSelected(menuItem.url, this.props.location.pathname);

                return menuItem;
            });

            this.setState({
                menuItems: menuItems,
                selectedRow: undefined
            });
        }
    }

    componentWillUnmount() {
        const { resetSurchargeRate } = this.props;
        resetSurchargeRate();
    }

    getSelectedMenuItem = (state: ISurchargeRateDetailsState) => state.menuItems.find(item => item.isSelected);

    handleMenuItems = () => {
        const { menuItems } = this.state;
        const selectedMenuItem = menuItems.find((item: IMenuItem) => item.isSelected);
        const selectedMenuItemId = selectedMenuItem?.id;
        const { surchargeRateId } = this.props.match.params;

        switch (selectedMenuItemId) {
            case 1: { //details
                return [
                    {
                        href: `${UrlConstants.SURCHARGE_RATES}/${surchargeRateId}/edit`,
                        icon: 'edit',
                        text: messages.edit
                    }
                ];
            }

            default: {
                return [];
            }
        }
    }

    render() {
        const { classes, isLoadingSurchargeRate } = this.props;
        const { surchargeRate, menuItems } = this.state;

        return (
            <MainLayout actions={this.handleMenuItems()}
                isLoading={isLoadingSurchargeRate}
                menuItems={menuItems}
                includeDrawer
                objectType={ObjectType.SurchargeRate}
                menuItem={{
                    id: 1,
                    subname: messages.subname,
                    value: surchargeRate?.id,
                    icon: <FontAwesomeIcon icon="file-invoice-dollar" size="1x" />
                } as IMenuItem}
            >
                <Container className={classes.container} maxWidth="xl">
                    <Switch>
                        <Route path={`/${UrlConstants.SURCHARGE_RATES}/:surchargeRateId/properties`}>
                            <ViewSurchargeRate surchargeRate={surchargeRate} />
                        </Route>
                    </Switch>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(SurchargeRateDetails));